export const PACKAGE_COVERAGE_OPTIMUM = 'optimum'
export const PACKAGE_COVERAGE_EXCELENT = 'excelent'
export const ALL_PACKAGE_COVERAGES = [
  PACKAGE_COVERAGE_OPTIMUM,
  PACKAGE_COVERAGE_EXCELENT,
] as const

export type PackageCoverages = typeof ALL_PACKAGE_COVERAGES[number]
